export function formatDate(date: Date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export function generateDateArray(startDate: Date, endDate: Date): DateRange[] {
  const result: DateRange[] = [];
  if (!startDate || !endDate) {
    return [];
  }
  // Calculate the difference in months
  const monthDifference =
    endDate.getMonth() -
    startDate.getMonth() +
    12 * (endDate.getFullYear() - startDate.getFullYear());

  if (monthDifference < 3) {
    // For less than 3 months, generate weekly dates
    let currentDate = new Date(startDate);
    while (currentDate.getDay() !== 1) {
      currentDate.setDate(currentDate.getDate() - 1);
    }
    result.push({
      startDate: new Date(currentDate),
      endDate: new Date(currentDate.setDate(currentDate.getDate() + 6)),
    });
    currentDate.setDate(currentDate.getDate() + 1);
    while (currentDate <= endDate) {
      result.push({
        startDate: new Date(currentDate),
        endDate: new Date(currentDate.setDate(currentDate.getDate() + 6)),
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }
  } else {
    // For 3 months or more, generate monthly dates
    const firstDayOfTheMonth = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      startDate.getFullYear(),
      startDate.getMonth() + 1,
      0
    );
    result.push({ startDate: firstDayOfTheMonth, endDate: lastDayOfMonth }); // Start with the startDate
    let currentDate = new Date(lastDayOfMonth);
    currentDate.setDate(currentDate.getDate() + 1); // Move to the next month
    while (currentDate <= endDate) {
      result.push({
        startDate: new Date(currentDate),
        endDate: new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          0
        ),
      });
      currentDate.setMonth(currentDate.getMonth() + 1); // Move to the next month
    }
  }
  return result;
}

export function convertToISODate(str: string) {
  str.trim();
  return str.replace(" ", "T");
}
